module.exports = __webpack_public_path__ + "static/img/8-yuan-icon.8efcb493.png";